import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "./ConfirmCancelDialog";
import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

class AdminAsiakasAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            AsiakasNimi: null,
            TenantId: null,
            Palvelupaketti_Id: 1,
            YritysTunnus: null,
            Created: null,
            Updated: null,
            Username: null,
            Active: null
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            AsiakasNimi: null,
            TenantId: null,
            Palvelupaketti_Id: 1,
            YritysTunnus: null,
            Created: null,
            Updated: null,
            Username: null,
            Active: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            RiviAvain: 1,
            AsiakasNimi: this.state.AsiakasNimi,
            TenantId: this.state.TenantId,
            Palvelupaketti_Id: this.state.Palvelupaketti_Id,
            YritysTunnus: this.state.YritysTunnus,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
            Active: this.state.Active
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <DialogTitle>{dictionary.AdminAsiakas.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <input type="hidden" value={this.state.RiviAvain} />
                        <TextField
                            margin="dense"
                            id="AsiakasNimi"
                            label={dictionary.AdminAsiakas.Columns[1]}
                            type="text"
                            fullWidth
                            value={this.state.AsiakasNimi}
                            onChange={this.handleChange('AsiakasNimi')}
                        />
                        <TextField
                            margin="dense"
                            id="TenantId"
                            label={dictionary.AdminAsiakas.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.TenantId}
                            onChange={this.handleChange('TenantId')}
                        />
                        <TextField
                            margin="dense"
                            id="YritysTunnus"
                            label={dictionary.AdminAsiakas.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.YritysTunnus}
                            onChange={this.handleChange('YritysTunnus')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminAsiakasAdd" })(AdminAsiakasAdd);
